import Plus from "../../../assets/icons/Plus";
import Rename from "../../../assets/icons/Rename";
import { updateMiscState } from "../../../misc/utils";
import { useGlobalMiscState } from "../../../stores/misc";
import DefaultButton from "../../default-button/DefaultButton";
import InputField from "../../input-field/InputField";

type Props = {
  setIsAddModalOpen: (value: boolean) => void;
  setIsChangeTable: (value: boolean) => void;
  buttonText: string;
  setSearchQuery: (query: string) => void;
};

export default function AccessesControl({
  setIsAddModalOpen,
  setIsChangeTable,
  buttonText,
  setSearchQuery,
}: Props) {
  const miscState = useGlobalMiscState()
  const accessesTableSearchValue = miscState.get('accessesTableSearchValue') || ""

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    miscState.set('accessesTableSearchValue', event.target.value)
  };

  return (
    <div className="flex items-center justify-between px-2 pt-2 pb-6">
      <div className="w-[26%]">
        <InputField
          type="text"
          placeholder="Поиск по пользователям"
          value={accessesTableSearchValue}
          handleChange={handleSearchChange}
        />
      </div>
      <div className="flex items-center gap-4">
        <DefaultButton
          buttonText="Добавить пользователя"
          additionalStyle="text-[#3BBC30] border-1 border-[#3BBC30] py-2 px-6 font-semibold"
          Icon={Plus}
          onClick={() => setIsAddModalOpen(true)}
        />
        {/* <DefaultButton
          buttonText={buttonText}
          additionalStyle={`border-1 border-[#0068FF] py-2 px-6 font-semibold ${
            buttonText === "Сохранить"
              ? "bg-[#0068FF] text-white px-8"
              : "text-[#0068FF] bg-white"
          }`}
          Icon={Rename}
          onClick={handleClick}
        /> */}
      </div>
    </div>
  );
}
